import { Box, Flex, Text } from "@chakra-ui/react";
import React from "react";
import { desktopOnlyDisplay, mobileOnlyDisplay } from "utils";
import { DecorativeBackgroundImage } from "components/images";
import { Section } from "components/section";
import { WarehouseNameRotation } from "components/animations";
import { TextColumn, type TextColumnProps } from "ui/text";
import image from "../../../../../public/assets/platform/reverse-etl/warehouse-performance.png";
import mobileImage from "../../../../../public/assets/platform/reverse-etl/warehouse-performance-mobile.png";
import { FeatureStatistics } from "./feature-statistics";

function TextCard({ title, description }: Pick<TextColumnProps, "title" | "description">) {
  return (
    <Box
      bg="brand.background.light"
      borderRadius="small"
      shadow="md"
      py="big"
      px="bigger"
      maxW={{ base: "100%", md: "50%", xl: "42%" }}
    >
      <TextColumn title={title} titleAs="h3" description={description} />
    </Box>
  );
}

export function WarehousePerformance() {
  return (
    <Section my="0">
      <Text
        as="h2"
        textStyle={{ base: "headline1", md: "display3" }}
        textAlign={{ base: "left", md: "center" }}
        maxW="700px"
        mx="auto"
      >
        High performance pipelines out of <WarehouseNameRotation />
      </Text>

      <Flex
        align="center"
        bg="brand.backgroundSecondary.light"
        borderRadius="bigger"
        justify="center"
        pos="relative"
        w="100%"
        mt={{ base: "bigger", md: "biggest" }}
        p={{ base: "smaller", md: "big" }}
        pb={{ base: "small", md: "big" }}
        overflow="hidden"
      >
        <Box pos="absolute" inset={0} display={mobileOnlyDisplay()}>
          <DecorativeBackgroundImage src={mobileImage} style={{ objectFit: "cover", objectPosition: "top center" }} />
        </Box>

        <Box pos="absolute" inset={0} display={desktopOnlyDisplay()}>
          <DecorativeBackgroundImage src={image} style={{ objectFit: "cover", objectPosition: "left center" }} />
        </Box>

        <Flex align="end" flexDir="column" gap="smaller" pos="relative" pt={{ base: "hugest", md: 0 }}>
          <TextCard
            title="Real-time syncing from the warehouse"
            description="Hightouch makes it easy to build low-latency pipelines. Under the hood, the sync engine listens for fresh data using your warehouse's native change data capture (CDC). No architectural puzzles — it just works."
          />

          <TextCard
            title="Ultra-fast and efficient batch jobs"
            description="Harness the compute horsepower of your warehouse to accelerate batch syncs. Every sync is optimized for speed, whether it's a small incremental update or a massive backfill."
          />
        </Flex>
      </Flex>

      <FeatureStatistics />
    </Section>
  );
}
